import logger from '@utils/logger';

const readEnvEndpoint = (key: string): string => {
	const value = process.env[key];
	if (!value) {
		if (process.env.NODE_ENV !== 'development') {
			logger.warn({ key }, 'env var not set — form submission will fail until helm values inject it');
		}
		return '';
	}
	return value;
};

export const CONTACT_FORM_ENDPOINT = readEnvEndpoint('PUBLIC_CONTACT_FORM_ENDPOINT');

export const CAREERS_FORM_ENDPOINT = readEnvEndpoint('PUBLIC_CAREERS_FORM_ENDPOINT');

export const MAX_FILE_SIZE = 9 * 1024 * 1024;
